import { warehouseApis } from '@apis/dashboard/warehouseApis';
import { createUseQuery } from '@hooks/createUseQuery';

export const useWarehouse = createUseQuery(
  (id: number) => ['/dashboard/warehouse/', id],
  (id) => () =>
    warehouseApis.get('/dashboard/warehouse/{id}/', { path: { id } }).then((r) => r[200]!),
);
